import { Box, SxProps } from '@mui/material';

import { InteractiveMap } from './InteractiveMap';

type MapProps = {
  longitude?: number | null;
  latitude?: number | null;
  width?: string | number;
  height?: string | number;
  sx?: SxProps;
  withBorder?: boolean;
  zoom?: number;
  isEditable?: boolean;
  onMarkerDragEnd?: (event: google.maps.MapMouseEvent) => void;
};

export const Map = ({
  longitude,
  latitude,
  width,
  height,
  sx,
  withBorder,
  zoom,
  isEditable = false,
  onMarkerDragEnd,
}: MapProps) => {
  const lat = Number(latitude);
  const lng = Number(longitude);
  const coordinates = Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : null;

  return (
    <Box
      sx={{
        ...(withBorder && { border: '1px solid', borderColor: 'divider' }),
        ...sx,
      }}
    >
      <InteractiveMap
        coordinates={coordinates}
        width={width}
        height={height}
        zoom={zoom}
        draggable={isEditable}
        markerDraggable={isEditable}
        onMarkerDragEnd={isEditable ? onMarkerDragEnd : undefined}
      />
    </Box>
  );
};
